import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";

import FourOfFour from "pages/404";
import Home from "pages/Home";
import Login from "pages/auth/Login";
import Register from "pages/auth/Register";
import Dash from "pages/App/App";
import Beta from "pages/Beta";


function App() {
    const [user] = useState(false);
    const [isDev, setToken] = useState(false);
    useState(() => {
        const token = localStorage.getItem("inDevelopment");
        console.log(token)
        if (token) {
            setToken(true);
        }
    }, [])
    return (
        <BrowserRouter>
            <Routes>
                {isDev ? (
                    <>
                        <Route path="/" element={<Home />} />

                        {!user ? (
                            <>
                                <Route path="/app" element={<Navigate to="/login" />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                            </>
                        ) : (
                            <>
                                <Route path="/app" element={<Dash />} />
                                <Route path="/login" element={<Navigate to="/app" />} />
                                <Route path="/register" element={<Navigate to="/app" />} />
                            </>
                        )}

                        <Route path="*" element={<FourOfFour />} />
                    </>
                ) : (
                    <>
                        <Route path="*" element={<Beta />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
